import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotate } from "@fortawesome/free-solid-svg-icons";
import { pageProps } from "../../../../helpers/pageProps";

interface StartButtonProps {
  isStartDisabled: boolean;
  starting: boolean;
  onStart: () => void;
  processGUID: string;
  processID: string;
  projectID: string | number;
}

export default function StartButton({
  isStartDisabled,
  starting,
  onStart,
  processGUID,
  processID,
  projectID,
}: StartButtonProps) {
  return (
    <>
      <button
        type="button"
        className="btn btn-colored form-control"
        onClick={onStart}
        disabled={isStartDisabled || starting}
      >
        Start
        {starting ? (
          <span className="ms-2">
            <FontAwesomeIcon icon={faRotate} spin />
          </span>
        ) : (
          ""
        )}
      </button>

      {isStartDisabled && (
        <div className="text-danger text-center">
          There are empty values in required fields
        </div>
      )}

      {processGUID !== "" ? (
        <div className="my-3">
          Process{" "}
          <a
            href={`${(pageProps as any).baseUrl}/workflows/reporting/processes/${projectID}/process/${processID}`}
            target="_blank"
            rel="noreferrer"
          >
            {processGUID}
          </a>{" "}
          started.
        </div>
      ) : (
        ""
      )}

      <div className="my-3">
        <a
          href={`${(pageProps as any).baseUrl}/workflows/reporting/processes/${projectID}`}
          target="_blank"
          rel="noreferrer"
        >
          See all
        </a>{" "}
        processes from this project.
      </div>
    </>
  );
}
